import { useSuspenseQuery } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import BundlePack from 'src/components/app/product/components/content/bundle-pack';

import Container from '@/components/@base/container';
import { PRODUCT_TABS } from '@/components/app/product/components/@shared/type';
import ChangeLog from '@/components/app/product/components/content/change-log';
import CommentsSummary from '@/components/app/product/components/content/comments-summary';
import Details from '@/components/app/product/components/content/details';
import FAQ from '@/components/app/product/components/content/faq';
import QuestionsSummary from '@/components/app/product/components/content/questions-summary';
import Props from '@/components/app/product/components/content/type';
import { getSingleProductOptions } from '@/components/app/product/services/hooks';
import { generateDefaultFaq } from '@/components/shared/helpers';
import useScrollTo from '@/components/shared/helpers/hooks/use-scroll-to';

import { DATA_CY_PRODUCT_DESCRIBE } from '@/constant/cypress';

export default function Content({
  slug,
  tabsPanelTopRef,
  onTabChange,
  onScrollToQuestionBox,
  isReadySite,
  aiReviewSummary,
}: Props) {
  const { data } = useSuspenseQuery(getSingleProductOptions(slug));
  const router = useRouter();
  const scrollToNode = useScrollTo();

  const handleShowMoreComments = () => {
    onTabChange && onTabChange(PRODUCT_TABS.COMMENTS);
    const showMoreCommentsPath = `/web/${slug}/${PRODUCT_TABS.COMMENTS}`;
    router.push(showMoreCommentsPath, { scroll: false });
    tabsPanelTopRef && scrollToNode(tabsPanelTopRef?.current, 100);
  };
  const handleShowMoreQuestions = () => {
    onTabChange && onTabChange(PRODUCT_TABS.QUESTIONS);
    const showMoreCommentsPath = `/web/${slug}/${PRODUCT_TABS.QUESTIONS}`;
    router.push(showMoreCommentsPath, { scroll: false });
    tabsPanelTopRef && scrollToNode(tabsPanelTopRef?.current, 100);
  };
  const handleAddQuestionClick = () => {
    onTabChange && onTabChange(PRODUCT_TABS.QUESTIONS);
    const showMoreCommentsPath = `/web/${slug}/${PRODUCT_TABS.QUESTIONS}`;
    router.push(showMoreCommentsPath, { scroll: false });
    onScrollToQuestionBox && onScrollToQuestionBox();
  };

  const faqData = data.faq && data.faq.length > 0 ? data.faq : generateDefaultFaq(data.title);

  return (
    <Container className='mx-0! w-full! px-0!' id='content' data-cy={DATA_CY_PRODUCT_DESCRIBE}>
      <Details content={data.contentHtml} isReadySite={isReadySite} />
      {data.changelog && (
        <ChangeLog
          totalVersions={data.changelog.totalVersions}
          log={data.changelog.log}
          showSmartUpdater={data.showSmartUpdater}
        />
      )}
      {data.reviews && data.reviews.length > 0 && (
        <CommentsSummary
          slug={slug}
          comments={data.reviews}
          rate={data.rate}
          handleShowMoreComments={handleShowMoreComments}
          aiReviewSummary={aiReviewSummary}
        />
      )}
      {data.questions && data.questions.length > 0 && (
        <QuestionsSummary
          questions={data.questions}
          rate={data.rate}
          handleShowMoreQuestions={handleShowMoreQuestions}
          handleAddQuestionClick={handleAddQuestionClick}
        />
      )}
      <FAQ faq={faqData} />
      {data.eliteBundle && <BundlePack {...data.eliteBundle} />}
    </Container>
  );
}
